<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="dataCard" class="body">
    <PageNotFound v-if="dataCard.code === 500" />
    <div v-else-if="dataCard.code === 400" class="error-response">
      <div class="icon-wrapper">
        <div class="icon-light" />
      </div>
      <h4 v-if="dataCard.count === 0">{{ $t('no_results_search') }}</h4>
      <h4 v-else>{{ $t('error_server_response') }}</h4>
    </div>
    <div v-else class="card-item">
      <div id="sticky-wrapper" class="sticky-header">
        <div class="sticky-title has-side-bars">
          <ItemIcon :type="dataCard.data[0].source" size="sm" :filled="true" />
          <!-- eslint-disable-next-line vue/no-parsing-error -->
          <h2>{{ isMobile ? (dataCard.data[0].title.length <= 80 ? dataCard.data[0].title : dataCard.data[0].title.slice(0, 77) + '...') : (dataCard.data[0].title.length <= 100 ? dataCard.data[0].title : dataCard.data[0].title.slice(0, 97) + '...') }}</h2>
        </div>
      </div>
      <MicroDataItem
        v-if="dataCard.data[0].source === 'MICRODATA'"
        :data-card="dataCard.data[0]"
        :data-values="dataCard.value && dataCard.value[0]"
        @reload-data-card="reloadDataCard"
      />
      <StatisticsTableItem v-else-if="dataCard.data[0].source === 'STATISTICS'" :data-card="dataCard" @reload-data-card="reloadDataCard" />
      <AppItem v-else-if="dataCard.data[0].source === 'DATASTORIES'" :data-card="dataCard" @reload-data-card="reloadDataCard" />
      <DocumentItem v-else-if="dataCard.data[0].source === 'DOCS'" :data-card="dataCard" @reload-data-card="reloadDataCard" />
      <EnquestesItem v-else-if="dataCard.data[0].source === 'SURVEY'" :data-card="dataCard" @reload-data-card="reloadDataCard" />
      <MapItem
        v-else-if="dataCard.data[0].source === 'MAPS'"
        :data-card="dataCard.data[0]"
        :data-values="dataCard.value && dataCard.value[0]"
        @reload-data-card="reloadDataCard"
      />
      <div v-else>
        <ItemCommonDescription :data-card="dataCard" @reload-data-card="reloadDataCard" />
        <div class="has-side-bars">
          <div class="item-data" />
        </div>
      </div>
    <!-- ItemViews / -->
    </div>
  </div>
  <div v-else class="body">
    <Loader :text="$t('loading')" />
  </div>
</template>

<script>
import PageNotFound from '../components/PageNotFound.vue'
import ItemIcon from '../components/ItemIcon.vue'
import { getItemById } from '@/services/api'
import ItemCommonDescription from '../components/items/ItemCommonDescription.vue'
import MicroDataItem from '../components/items/MicroDataItem.vue'
import StatisticsTableItem from '../components/items/StatisticsTableItem.vue'
import AppItem from '../components/items/AppItem.vue'
import DocumentItem from '../components/items/DocumentItem.vue'
import EnquestesItem from '../components/items/EnquestesItem.vue'
import MapItem from '../components/items/MapItem.vue'
import Loader from '../components/Loader.vue'

/**
 * The Item view page (shows the item information and data getted by url param cardId)
 * @displayName Item
 * @example [none]
 */
export default {
  //components: { ItemHeader, ItemDescription, ItemAdditions, ItemViews, Loader, ItemList },
  components: {
    PageNotFound,
    ItemIcon,
    ItemCommonDescription,
    MicroDataItem,
    StatisticsTableItem,
    AppItem,
    DocumentItem,
    EnquestesItem,
    MapItem,
    Loader,
  },
  props: {
    /**
     * Id of printed card
     */
    cardId: {
      type: String,
    },
    /**
     * Source type of the item
     */
    type: {
      type: String,
    },
  },
  data() {
    return {
      titleGrow: false,
      asyncCount: 0
    }
  },
  metaInfo (){
    return {
      title: this.dataCard ? this.dataCard.data[0].title +' | '+this.$t('cover_title') : this.$t('cover_title'),
      meta: [
        {
          name: 'title',
          content: this.dataCard ? this.dataCard.data[0].title +' | '+this.$t('cover_title') : this.$t('cover_title')
        }
      ]
    }
  },
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
    sourceToApi() {
      if (this.$getTypesOfContent?.data && this.$getTypesOfContent?.data?.length !== 0) {
        if (
          this.$getTypesOfContent.data.find(el => el.type === 'MICRODATA') &&
          this.type ===
            this.$getTypesOfContent.data.find(el => el.type === 'MICRODATA').label[this.currentLang]
        )
          return 'microdata'
        else if (
          this.$getTypesOfContent.data.find(el => el.type === 'STATISTICS') &&
          this.type ===
            this.$getTypesOfContent.data.find(el => el.type === 'STATISTICS').label[
              this.currentLang
            ]
        )
          return 'statistic'
        else if (
          this.$getTypesOfContent.data.find(el => el.type === 'SURVEY') &&
          this.type ===
            this.$getTypesOfContent.data.find(el => el.type === 'SURVEY').label[this.currentLang]
        )
          return 'survey'
        else if (
          this.$getTypesOfContent.data.find(el => el.type === 'DOCS') &&
          this.type ===
            this.$getTypesOfContent.data.find(el => el.type === 'DOCS').label[this.currentLang]
        )
          return 'document'
        else if (
          this.$getTypesOfContent.data.find(el => el.type === 'MAPS') &&
          this.type ===
            this.$getTypesOfContent.data.find(el => el.type === 'MAPS').label[this.currentLang]
        )
          return 'map'
        else if (
          this.$getTypesOfContent.data.find(el => el.type === 'DATASTORIES') &&
          this.type ===
            this.$getTypesOfContent.data.find(el => el.type === 'DATASTORIES').label[
              this.currentLang
            ]
        )
          return 'datastory'
        else return 'item'
      } else return 'item'
    },
  },
  asyncComputed: {
    dataCard() {
      //using asyncCount to reload data
      console.log(this.asyncCount)
      return getItemById(this.cardId, this.currentLang, this.sourceToApi, true).then(resp => {
        if (resp.code !== 500) {
          let favs = resp.data[0].favourites
          if (favs.length > 0) {
            let el = favs.find(ele => ele.payload && window.location.search !== "" && ele.payload.indexOf(window.location.search.substring(1, window.location.search.length)) !== -1)
            if (el) {
              if(window.location.search.substring(1, window.location.search.length) !== el.payload) {
                let langSource = null
                if (this.$store.state.i18n.lang === 'ca') langSource = 'estad%C3%ADstiques'
                else if (this.$store.state.i18n.lang === 'es') langSource = 'estad%C3%ADsticas'
                else if (this.$store.state.i18n.lang === 'en') langSource = 'statistics'
                this.$router.push('/' + this.$store.state.i18n.lang + '/' + langSource + '/' + resp.data[0].id + '?' + el.payload)
              }
            }
          }
        }
        return resp
      })
    },
  },
  methods: {
    reloadDataCard() {
      this.asyncCount += 1
    },
    /**
     * Navigate to home page or go back 1 page of history if it exist
     * @public This is a public method
     */
    backHandler: function () {
      if (window.history?.length > 2) {
        this.$router.back()
      } else this.$router.push('/')
    },
  },
}
</script>

<style lang="stylus" scoped>
.card-item
  flex: 1 1 0%
  background-color: #fff

  .sticky-header
    position: fixed
    top: "calc(%s + %s)" % ($subheader-height vw(30px))
    z-index: 7
    display: none
    width: 100%
    height: vw(60px)
    border-bottom: 1px solid $bcn-other-grey
    background: linear-gradient(135deg, rgba(#54AEEF, 0.05) 0, rgba(#7360EA, 0.05) 100%)
    background-color: #fff

    .sticky-title
      display: flex
      align-items: center
      gap: vw(15px)

      h2
        m-font-size(24, 28)
        font-weight: 600
        margin-block-start: 0
        margin-block-end: 0

        .mobile &
          m-font-size(18, 22)

  .title-grow
    display: flex
    transform-origin: top center
    animation: growDown 0.2s ease-in-out forwards

  @keyframes growDown
    0%
      transform: scaleY(0)

    100%
      transform: scaleY(1)

  .item-data
    margin-top: vw(10px)
    width: 100%
    height: 500px
    background-color: lightgrey

  .back-wrapper
    display: flex
    align-items: center
    cursor: pointer

    .back-icon
      margin-right: vw(5px)
      m-icon("chevron-down", 25)
      transform: rotate(90deg)

.error-response
  position: absolute
  top: 50%
  left: 50%
  display: flex
  flex-direction: column
  align-items: center
  transform: translate(-50%, -50%)

  .icon-wrapper
    display: flex
    justify-content: center
    align-items: center
    margin-bottom: vw(20px)
    width: vw(78px)
    height: vw(78px)
    border-radius: 50%
    background-color: $bcn-grey

    .icon-light
      m-icon("light", 42)
</style>
